import { HIDE_TOOLTIP, RESET_STATE } from '../../../../reducer';
export const TOGGLE_SHOW_SUMMARY = 'directMerchants/TOGGLE_SHOW_SUMMARY';
export const TOGGLE_SHOW_DETAILED_SUMMARY =
  'directMerchants/TOGGLE_SHOW_DETAILED_SUMMARY';
export const SET_SHOW_SUMMARY_TOGGLED =
  'directMerchants/SET_SHOW_SUMMARY_TOGGLED';
export const SET_SHOW_DETAILED_SUMMARY_TOGGLED =
  'directMerchants/SET_SHOW_DETAILED_SUMMARY_TOGGLED';
export const SHOW_TOOLTIP = 'directMerchants/SHOW_TOOLTIP';
export const CHANGE_SORT_ORDER = 'directMerchants/CHANGE_SORT_ORDER';

export const toggleShowSummary = () => ({
  type: TOGGLE_SHOW_SUMMARY
});

export const toggleShowDetailedSummary = () => ({
  type: TOGGLE_SHOW_DETAILED_SUMMARY
});

export const setShowSummaryToggled = () => ({
  type: SET_SHOW_SUMMARY_TOGGLED
});

export const setShowDetailedSummaryToggled = () => ({
  type: SET_SHOW_DETAILED_SUMMARY_TOGGLED
});

export const showTooltip = activeTooltip => ({
  type: SHOW_TOOLTIP,
  activeTooltip
});

export const changeSortOrder = orderBy => ({
  type: CHANGE_SORT_ORDER,
  orderBy
});

export const resetState = () => ({
  type: RESET_STATE
});

const initialState = {
  activeTooltip: null,
  orderBy: null,
  orderDirection: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_SHOW_SUMMARY:
      return {
        ...state,
        showSummary: !state.showSummary
      };
    case TOGGLE_SHOW_DETAILED_SUMMARY:
      return {
        ...state,
        showDetailedSummary: !state.showDetailedSummary
      };
    case SET_SHOW_SUMMARY_TOGGLED:
      return {
        ...state,
        showSummary: true
      };
    case SET_SHOW_DETAILED_SUMMARY_TOGGLED:
      return {
        ...state,
        showDetailedSummary: true
      };
    case SHOW_TOOLTIP:
      return {
        ...state,
        activeTooltip: action.activeTooltip
      };
    case HIDE_TOOLTIP:
      return {
        ...state,
        activeTooltip: null
      };
    case CHANGE_SORT_ORDER:
      return {
        ...state,
        // TODO: write a function to determine logic for sorting order.
        orderBy:
          action.orderBy === state.orderBy && state.orderDirection === 'asc'
            ? null
            : action.orderBy,
        orderDirection:
          state.orderBy === action.orderBy && state.orderDirection === 'desc'
            ? 'asc'
            : 'desc'
      };
    case RESET_STATE:
      return {
        ...state,
        ...initialState
      };
    default:
      return state;
  }
};
